module.exports = __webpack_public_path__ + "img/solomonislands.d3e1819a.svg";